import { create } from 'zustand';

import { closeSession, openSession, patchSession, type ResultDetailTab, type ResultPanelTab, type SessionInit, type SessionMap } from './sessions';

// In memory only: a period's sessions die with its board
export interface ResultSessionState {
  sessions: SessionMap;
  open: (init: SessionInit) => void;
  close: (tabId: string) => void;
  setPanelTab: (tabId: string, tab: ResultPanelTab) => void;
  setDetailTab: (tabId: string, tab: ResultDetailTab) => void;
  /** Puts the student's work in place of the đề, on the given part. */
  openStudent: (tabId: string, code: string, item?: number) => void;
  /** Back to the đề. */
  closeStudent: (tabId: string) => void;
  selectItem: (tabId: string, item: number) => void;
  setView: (tabId: string, view: string | null) => void;
  clear: () => void;
}

export const useResultSessionStore = create<ResultSessionState>((set, get) => ({
  sessions: {},
  open: (init) => set({ sessions: openSession(get().sessions, init) }),
  close: (tabId) => set({ sessions: closeSession(get().sessions, tabId) }),
  setPanelTab: (tabId, tab) => set({ sessions: patchSession(get().sessions, tabId, { panelTab: tab }) }),
  setDetailTab: (tabId, tab) => set({ sessions: patchSession(get().sessions, tabId, { detailTab: tab }) }),
  openStudent(tabId, code, item = 0) {
    const session = get().sessions[tabId];
    if (session) set({ sessions: patchSession(get().sessions, tabId, { student: code, item, tick: session.tick + 1 }) });
  },
  closeStudent: (tabId) => set({ sessions: patchSession(get().sessions, tabId, { student: null, item: 0, view: null }) }),
  selectItem(tabId, item) {
    const session = get().sessions[tabId];
    if (session) set({ sessions: patchSession(get().sessions, tabId, { item, tick: session.tick + 1 }) });
  },
  setView: (tabId, view) => {
    const session = get().sessions[tabId];
    if (session && session.view !== view) set({ sessions: patchSession(get().sessions, tabId, { view }) });
  },
  clear: () => set({ sessions: {} }),
}));
